import React from 'react';
import {Bar} from 'react-chartjs-2';

class BarChart extends React.Component{

  render() {
       
const data = {
    labels: [ 'Before Last Month', 'Last Month', 'This month',  ],
    datasets: [
      {
        label: 'Requests',
        backgroundColor: '#ff9466',
        borderColor: '#d3661d',
        borderWidth: 1,
        hoverBackgroundColor: '#d3661d',
        hoverBorderColor: '#030303',
        data: this.props.barChartValues
      }
    ]
  };

  
  

    return (
      <div>
         <Bar
          data={data}
          width={150}
          height={305}
          options={{
            maintainAspectRatio: false
          }}
        />
      </div>
    );
  }
}

export default BarChart;